type ExcludedHttpCall =
    | string
    | { path: string; method: string[] }
    | { paths: string[]; method: string[] };

export const EXCLUDED_HTTP_CALLS: ExcludedHttpCall[] = [
	// IP API Is an external service used during onboarding, to geo-locate the user. Their API sometimes fail and we want to silently ignore that, as this operation is not mandatory
	'pro.ip-api.com',
	// TestWebhookEvent contains specipic error handaling (error can be from customer endpoint as well) so we don't need general error here
	'api/integrations/TestWebhookEvent',
	// Closing error - more specific message that notifies that the request hasn’t been closed
	'api/actions/closeRequestV2',
	// Privacy center URL error - contains a spesific error message
	'api/privacycenter/RequestFormConfig',
	// Invite member - contains a spesific error message
	'api/actions/InviteMember?',
	// SendReply has a special message to show on status 400
	'api/actions/SendReply',
	// Called from my billing button in plans page - we want to avoid the snackbar
	'api/profileportal/PlanManagementsPage',
	// File upload shows error under the button if there is an issue with file
	'api/settings/icon/validateAndSave',
	// Creating new assessment error is shown in an info-box
	{ path: '/api/assessment/v2/assessment-page', method: ['POST'] },
	// Get domain for brand returns 404 when no custom domain; service returns default sender and no snackbar
	'custom-domain/dsr',
	// Delete banner has specific error handling in the component
	{ path: '/api/cmp/v1/domain-groups', method: ['DELETE'] },
	// Publish domain group errors are shown inside the publish dialog
	{ paths: ['/api/cmp/v1/domain-groups', '/publish'], method: ['POST'] },
	// Autofill trigger returns 409 when a Company run is already in progress;
	// component shows its own snackbar with the BE message
	{ paths: ['/api/autofill/', '/trigger'], method: ['POST'] },
	// Delete locale returns 409 with brand IDs when the locale is active in a Privacy Center
	{ path: '/api/dsr/v1/globallocales/', method: ['DELETE'] },
	// Delete right returns 409 with brand IDs when the right is active in a Privacy Center
	{ path: '/api/dsr/v1/rights/', method: ['DELETE'] },
	// Disable right (PATCH display-settings) returns 409 with brand IDs when active in a Privacy Center
	{ paths: ['/api/dsr/v1/rights/', '/display-settings'], method: ['PATCH'] },
	// Compile copy report returns 400 with a user-facing reason (e.g. files still being redacted);
	// data-collection-processing-completed shows it in its own snackbar
	{ path: '/workflow/tasks/data-collection/report', method: ['POST'] },
];
